const seo: Record<string, string> = {
  "site.title": "韩国伦理片精选推荐｜高分必看合集2024 - 韩影精选",
  "site.description": "精选韩国伦理片高分榜单，涵盖经典与最新韩国伦理电影推荐，深度解析剧情、演员与导演风格。无论是禁忌爱情还是社会批判题材，带你发现韩国伦理片的艺术价值与观影魅力。",
  "site.keywords": "韩国伦理片,韩国伦理电影,韩国伦理片推荐,韩国限制级电影,韩国高分伦理片,韩国禁忌电影,韩国成人电影",
  "home.title": "韩影精选 - 韩国伦理片高分推荐与深度解析",
  "category.title": "分类浏览 - 韩影精选",
  "article.title_prefix": "深度解析 - 韩影精选",
  "about.title": "关于我们 - 韩影精选",
};

export default seo;